import React from 'react';
import { useSettingsStore } from '../store/settingsStore';
import whatsappIcon from '../assets/whatsapp.png';

export const WhatsAppBubble: React.FC = () => {
  const whatsappNumber = useSettingsStore((state) => state.whatsappNumber);

  return (
    <div className="fixed bottom-[82px] right-6 z-40 no-print font-sans">
      <a
        href={`https://wa.me/${whatsappNumber.replace(/^\+/, '')}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-12 h-12 flex items-center justify-center rounded-full shadow-xl hover:scale-110 transition-transform duration-300 relative group focus:outline-none"
        aria-label="Contact WhatsApp Support"
      >
        <img
          src={whatsappIcon}
          alt="Chat on WhatsApp"
          className="w-12 h-12 object-contain rounded-full"
        />
        <span className="absolute -inset-0.5 rounded-full bg-[#25d366]/30 -z-10 animate-ping"></span>
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-slate-900 text-white text-[10px] font-bold py-1 px-2.5 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap">
          WhatsApp
        </span>
      </a>
    </div>
  );
};
